import routeConfig from './config/RouteConfig';
import 'angularRouter';
import 'edge/platform/widgets/carousel/module';
import AuthenticationService from 'plugin?auth-type!gw-portals-auth-js/AuthenticationService';
import 'plugin?auth-type!gw-portals-auth-angular/module';

export default angular.module('edge.platform.segmentation.demolandingpage', ['ui.router', 'edge.platform.widgets.carousel', 'edge.platform.auth']).config(['$stateProvider', function ($stateProvider) {
    for (var stateName in routeConfig) {
        if (routeConfig.hasOwnProperty(stateName)) {
            $stateProvider.state(stateName, routeConfig[stateName]);
        }
    }
}]).run(['$state', 'state_plugin_config', '$q', 'oAuth', '$timeout', function ($state, appConfig, $q, oAuth, $timeout) {
    var authenticationService = AuthenticationService(oAuth);
    var handlerFn = function handlerFn() {
        $timeout(function () {
            // need to put inside $timeout to allow a digest cycle to run and set initial state
            var homePage = appConfig.home;
            if ($state.current.name === homePage) {
                $state.go('loadingLandingPage', {
                    params: $state.params
                });
            }
        });
    };

    // when app is loaded go to a loading page while we wait for authentication response and any segmentation decisions to be made
    authenticationService.waitForLoginRequestComplete.then(handlerFn, handlerFn);
}]);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/segmentation/demolandingpage/module.js
// module id = 1070
// module chunks = 0